import React from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import {
    buildGroupStructureRecords,
    GROUP_STRUCTURE_COLUMNS,
    resolveGroupStructureGraph,
} from "../../helpers/groupStructureGraph";
import { EntityRecordsTable, GroupStructureGraph, SectionTitle } from "../../shared";

const GroupStructureGraphSection = ({ supplierData = {}, meta }) => {
    const graphData = resolveGroupStructureGraph(supplierData);
    const groupRecords = buildGroupStructureRecords(graphData);

    return (
        <View style={styles.wordSectionContent}>
            <EntityRecordsTable
                leading={(
                    <SectionTitle
                        title={meta?.title || "Group Structure Graph"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
                columns={GROUP_STRUCTURE_COLUMNS}
                records={groupRecords}
            />
            <GroupStructureGraph graphData={graphData} />
        </View>
    );
};

export default withNamespaces()(GroupStructureGraphSection);
